type OptionWithId = { id: string };

export const isOptionEqualById = <TOption extends OptionWithId>(option: TOption, value: string | TOption) => {
  if (typeof value === 'object') {
    return option.id === value.id;
  }

  return option.id === value;
};
